<div class="event-orders-map">
  <!-- Carga inicial de datos del evento -->
  <div *ngIf="loading" class="loading-container-panel w-100 d-flex justify-content-center">
    <div class="container-lottie">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <!-- El evento no usa mapa de butacas -->
    <div *ngIf="!useMapVenue || !map" class="info-default no-map">
      <p class="m-0">
        <i class="fa-light fa-circle-info icon-primary" style="margin-right: 8px;"></i>
        Este evento no tiene un mapa de butacas asociado.
      </p>
    </div>

    <div class="container-map-venue" *ngIf="useMapVenue && map">
      <!-- Selección de sesión (solo con varias sesiones) -->
      <div class="select-sessions-map mb-3" *ngIf="sessionsList?.length > 1">
        <p class="select-session-label mb-0">Seleccionar sesión</p>
        <div class="container-filters">
          <mat-form-field appearance="fill" class="select-filter-panel mat-select-session">
            <mat-select class="text-black" panelClass="selectPanelControl"
              placeholder="Seleccionar sesión" [(ngModel)]="selectedSession"
              (ngModelChange)="changeSession()" disableOptionCentering="false">
              <mat-option *ngFor="let session of sessionsList" [value]="session.id">
                <span>{{getSessionDateString(session)}}</span>
              </mat-option>
            </mat-select>
            <mat-select-trigger matSuffix style="vertical-align: middle;">
              <i class="fal fa-angle-down pointer-in"></i>
            </mat-select-trigger>
          </mat-form-field>
        </div>
      </div>

      <div class="info-default">
        <p class="m-0">
          <i class="fa-light fa-circle-info icon-primary" style="margin-right: 8px;"></i>
          Pasa el cursor por encima de una butaca ocupada para ver el pedido al que
          pertenece, o haz clic para abrir su detalle.
        </p>
      </div>

      <div *ngIf="loadingBlockedSeats || loadingMap"
        class="loading-container-panel map-loading-container w-100 d-flex justify-content-center">
        <div class="container-lottie">
          <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
        </div>
      </div>

      <div *ngIf="!loadingBlockedSeats" [hidden]="loadingMap">
        <!-- allowCreate=false: vista de solo lectura, sin panel de bloqueos. Las butacas
             ocupadas se pintan igualmente y el hover muestra el pedido al que pertenecen. -->
        <app-create-map [fromCreate]="true" [fromEvent]="true" [idEvent]="idEvent" [idSpace]="venue?.id"
          [venue]="venue" [idMap]="map?.id" [allowCreate]="false"
          [blockedSeats]="blockedSeats" [selectedSession]="selectedSession"
          (loadingChange)="onMapLoadingChange($event)"></app-create-map>
      </div>
    </div>
  </ng-container>
</div>
